import { render } from "./DrKarishmaAggarwal.vue?vue&type=template&id=18956014"
import script from "./DrKarishmaAggarwal.vue?vue&type=script&lang=js"
export * from "./DrKarishmaAggarwal.vue?vue&type=script&lang=js"

import "./DrKarishmaAggarwal.vue?vue&type=style&index=0&id=18956014&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__